import React from 'react';
import './NoDataFound.css';
import { LANGUAGE } from '../../utils/languageProperties';

const NoDataFound: React.FC<{ isClassName?: boolean }> = ({ isClassName = true }) => {
    return (
        <div
            className={
                isClassName
                    ? 'empty-data-container'
                    : 'empty-data-container-none'
            }
        >
            <div>
                <svg
                    width="180"
                    height="180"
                    viewBox="0 0 180 180"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M154.688 40.293H33.75C31.5122 40.293 29.3661 41.1819 27.7838 42.7643C26.2014 44.3466 25.3125 46.4927 25.3125 48.7305V65.6055H154.688V40.293Z"
                        fill="#C5EBF7"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M154.687 35.5508C154.687 33.313 153.799 31.1669 152.216 29.5846C150.634 28.0022 148.488 27.1133 146.25 27.1133H102.153C100.17 27.1131 98.2217 27.6372 96.5063 28.6325C94.7909 29.6277 93.3691 31.0587 92.385 32.7805L84.375 46.8008H154.687V35.5508Z"
                        fill="#C5EBF7"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M25.3125 48.2031H154.688V53.4428H25.3125V48.2031Z"
                        fill="#002A56"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M164.161 64.4364C164.381 62.8436 164.258 61.2219 163.799 59.6808C163.34 58.1396 162.557 56.7146 161.501 55.5017C160.445 54.2889 159.141 53.3164 157.678 52.6497C156.215 51.983 154.626 51.6376 153.018 51.6367H26.9838C25.3754 51.6367 23.7858 51.9815 22.322 52.6479C20.8583 53.3143 19.5544 54.2868 18.4983 55.4998C17.4423 56.7129 16.6586 58.1382 16.2002 59.6798C15.7417 61.2214 15.6191 62.8434 15.8406 64.4364L26.7785 143.186C27.1525 145.876 28.4866 148.339 30.5346 150.122C32.5826 151.905 35.2063 152.887 37.9216 152.887H142.08C144.795 152.887 147.419 151.905 149.467 150.122C151.515 148.339 152.849 145.876 153.223 143.186L164.161 64.4364Z"
                        fill="#D4F3FA"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.7856 71.2427C17.0376 68.4442 18.3269 65.8412 20.4002 63.9448C22.4735 62.0485 25.1809 60.9959 27.9906 60.9939H152.011C154.821 60.9934 157.53 62.045 159.604 63.9419C161.678 65.8387 162.966 68.4433 163.216 71.2427L164.161 64.4364C164.381 62.8436 164.258 61.2219 163.799 59.6808C163.34 58.1396 162.557 56.7146 161.501 55.5017C160.445 54.2889 159.141 53.3164 157.678 52.6497C156.215 51.983 154.626 51.6376 153.018 51.6367H26.9838C25.3754 51.6367 23.7858 51.9815 22.322 52.6479C20.8583 53.3143 19.5544 54.2868 18.4983 55.4998C17.4423 56.7129 16.6586 58.1382 16.2002 59.6798C15.7417 61.2214 15.6191 62.8434 15.8406 64.4364L16.7856 71.2427Z"
                        fill="#C5EBF7"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M77.3457 124.836C77.3457 123.344 76.7531 121.913 75.6982 120.858C74.6433 119.803 73.2125 119.211 71.7207 119.211H49.2207C47.7289 119.211 46.2981 119.803 45.2432 120.858C44.1883 121.913 43.5957 123.344 43.5957 124.836V130.461C43.5957 131.952 44.1883 133.383 45.2432 134.438C46.2981 135.493 47.7289 136.086 49.2207 136.086H71.7207C73.2125 136.086 74.6433 135.493 75.6982 134.438C76.7531 133.383 77.3457 131.952 77.3457 130.461V124.836ZM119.53 72C103.232 72 89.9991 85.2328 89.9991 101.531C89.9991 117.83 103.232 131.063 119.53 131.063C135.829 131.063 149.062 117.83 149.062 101.531C149.062 85.2328 135.829 72 119.53 72ZM119.53 80.4375C131.171 80.4375 140.624 89.8903 140.624 101.531C140.624 113.172 131.171 122.625 119.53 122.625C107.889 122.625 98.4366 113.172 98.4366 101.531C98.4366 89.8903 107.889 80.4375 119.53 80.4375Z"
                        fill="#003764"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M134.915 121.927L161.15 148.162C161.941 148.953 163.014 149.398 164.133 149.398C165.252 149.398 166.325 148.954 167.117 148.163C167.908 147.372 168.353 146.299 168.353 145.18C168.353 144.061 167.909 142.988 167.118 142.196L140.883 115.961C140.083 115.214 139.024 114.806 137.93 114.825C136.835 114.843 135.791 115.286 135.016 116.06C134.242 116.834 133.799 117.878 133.78 118.973C133.761 120.067 134.168 121.126 134.915 121.927Z"
                        fill="#003764"
                    />
                </svg>
            </div>
            <h1 className="empty-data-heading">{LANGUAGE['no-data-found']}</h1>
            <div className="empty-data-subheading">
                {LANGUAGE['no-data-found-description']}
            </div>
        </div>
    );
};

export default NoDataFound;
